import { useTranslate } from '@tolgee/react';

import { OPERATION_TYPES } from '~/shared/constants/OPERATION_TYPES';
import { ORIGIN_SOURCE } from '~/shared/constants/ORIGIN_SOURCE';
import { REQUEST_STATUS_OPTIONS } from '~/shared/constants/REQUEST_STATUS_OPTIONS';
import { ETolgeeNamespaces } from '~/shared/enums/ETolgeeNamespaces';
import { useCompanyFilters } from '~/shared/hooks/useCompanyFilters';
import { sortSelectOptions } from '~/shared/utils/sortSelectOptions';

export function useOptions(fetchCompanies?: boolean) {
  const { companies } = useCompanyFilters(fetchCompanies);
  const { t: tDefault } = useTranslate(ETolgeeNamespaces.DEFAULT);

  const translatedOperationTypes = sortSelectOptions(
    OPERATION_TYPES.map(operation => ({
      label: tDefault(operation.label),
      value: operation.value
    }))
  );

  const translatedStatusOptions = sortSelectOptions(
    REQUEST_STATUS_OPTIONS.map(status => ({
      label: tDefault(status.label),
      value: status.value
    }))
  );

  const translatedOriginSource = sortSelectOptions(
    ORIGIN_SOURCE.map(origin => ({
      label: tDefault(origin.label),
      value: origin.value
    }))
  );

  const normalizedCompanies = sortSelectOptions(
    (companies || []).map(company => ({
      label: company.companyName,
      value: company.companyId
    }))
  );

  return {
    operationTypes: translatedOperationTypes,
    status: translatedStatusOptions,
    originSource: translatedOriginSource,
    companies: normalizedCompanies
  };
}
